import { useQuery } from '@tanstack/react-query';
import { getRestaurantReferral, queryKeys } from '@vgrubs/components';
import { isAxiosError } from 'axios';

/**
 * One referral, for its page. A 404 (it does not exist, or the program does
 * not count it) is an answer rather than an error, so it is not retried.
 */
export const useReferral = (referralId: string | undefined) => {
  const query = useQuery({
    queryKey: queryKeys.restaurantReferrals.detail(referralId ?? ''),
    queryFn: async () => {
      const { data } = await getRestaurantReferral(referralId as string);
      return data.data;
    },
    enabled: !!referralId,
    retry: (count, error) =>
      !(isAxiosError(error) && error.response?.status === 404) && count < 2,
  });

  return {
    referral: query.data ?? null,
    isLoading: query.isLoading,
    notFound: isAxiosError(query.error) && query.error.response?.status === 404,
  };
};
